// extracted by mini-css-extract-plugin
module.exports = {"pageLink":"PageLink_pageLink__Okzcv","direction":"PageLink_direction__Z691R"};